import $ from "jquery";
import Bowser from "bowser";

const UserAgent = () => {
  const browser = Bowser.getParser(window.navigator.userAgent);
  console.log(browser.getPlatformType());

  if (browser.getPlatformType() !== "desktop") {
    /** EPISODES ARROWS */
    $(".slick-next.slick-arrow").hide();
    $(".slick-prev.slick-arrow").hide();

    /** POLOS ARROWS */
    $(".swiper-button-next").hide();
    $("swiper-button-prev").hide();

    /** EDUCATORS ARROWS */
    $(".swiper-button-next2").hide();
    $("swiper-button-prev2").hide();
  } else {
    /** EPISODES ARROWS */
    $(".slick-next.slick-arrow").show();
    $(".slick-prev.slick-arrow").hide();

    // /** POLOS ARROWS */
    $(".swiper-button-next").show();
    $("swiper-button-prev").hide();

    /** EDUCATORS ARROWS */
    $(".swiper-button-next2").show();
    $("swiper-button-prev2").hide();
  }
};

export default UserAgent;
